import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

$(() => {
  $('.carousel').each(function () {
    const $carousel = $(this);
    const hasLessWidthClass = $carousel.hasClass('-less-width');

    const carouselSwiper = new Swiper($carousel.find('.swiper')[0], {
      slidesPerView: 1,
      spaceBetween: 30,
      // autoplay: {
      //   delay: 5000,
      // },
      pagination: {
        el: $carousel.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: $carousel.find('.swiper-button-next')[0],
        prevEl: $carousel.find('.swiper-button-prev')[0],
      },
      breakpoints: {
        768: {
          slidesPerView: hasLessWidthClass ? 1.51 : 1,
        },
      },
    });
  });

  const quoteSwiper = new Swiper('.quote .swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  const awardSlider = new Swiper('.awards-slider .swiper', {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      // reverseDirection: true,
    },
    speed: 2000,
    breakpoints: {
      768: {
        slidesPerView: 4.9,
        spaceBetween: 54,
      },
    },
  });

  // Add event listeners for mouseenter and mouseleave
  const awardSliderContainer = document.querySelector('.awards-slider .swiper');

  if (awardSliderContainer) {
    awardSliderContainer.addEventListener('mouseenter', () => {
      awardSlider.autoplay.stop();
    });

    awardSliderContainer.addEventListener('mouseleave', () => {
      awardSlider.autoplay.start();
    });
  }

  const heroSlider = new Swiper('.hero-slider', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 3000,
    loop: true,
    breakpoints: {
      1200: {
        allowTouchMove: false
      }
    }
  });

  heroSlider.on('slideChange', function () {
    var $slideIndex = heroSlider.realIndex;
    const $slideImage = $('.hero-slider__image');
    const $slideVideo = $('.hero-slider__video');

    $('.hero-slider__nav-item').removeClass('active');
    $('.hero-slider__nav-item[data-slide='+ $slideIndex +']').addClass('active');
    $slideImage.removeClass('active');
    $slideVideo.removeClass('active');
    $('.hero-slider__background-' + $slideIndex).addClass('active');
  });

  $('.hero-slider__nav-item[data-slide]').on('click', function(e) {
    const $slideData = $(this).data('slide');
    heroSlider.slideTo(($slideData + 1));
  });
});
